/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupAssignment
 */
export interface UserGroupAssignment {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignment
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof UserGroupAssignment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserGroupAssignment
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignment
     */
    userGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignment
     */
    userId: string;
}

/**
 * Check if a given object implements the UserGroupAssignment interface.
 */
export function instanceOfUserGroupAssignment(value: object): value is UserGroupAssignment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('userGroupId' in value) || value['userGroupId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function UserGroupAssignmentFromJSON(json: any): UserGroupAssignment {
    return UserGroupAssignmentFromJSONTyped(json, false);
}

export function UserGroupAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'userGroupId': json['userGroupId'],
        'userId': json['userId'],
    };
}

export function UserGroupAssignmentToJSON(json: any): UserGroupAssignment {
    return UserGroupAssignmentToJSONTyped(json, false);
}

export function UserGroupAssignmentToJSONTyped(value?: UserGroupAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'userGroupId': value['userGroupId'],
        'userId': value['userId'],
    };
}

